var Event = require('./event.js')

module.exports = Single

function Single() {
    var tuple = Event()

    return function event(value) {
        if (typeof value === "function") {
            return tuple.listen(value)
        } else {
            return tuple.broadcast(value)
        }
    }
}



//////////////////
// WEBPACK FOOTER
// ./~/geval/single.js
// module id = 45
// module chunks = 0